export default __webpack_public_path__ + "static/media/runestone_144.2620597d.png";